import { jsx as _jsx } from "react/jsx-runtime";
import { Routes, Route } from "react-router-dom";
import { useMemo } from "react";
import { AppRoutes } from "./routes";
export const RouterManager = () => {
    const routes = useMemo(() => Object.keys(AppRoutes).map((path) => {
        const RouteComponent = AppRoutes[path];
        return _jsx(Route, { path: path, element: _jsx(RouteComponent, {}) }, path);
    }), []);
    return _jsx(Routes, { children: routes });
};
